import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { EmailTemplateClient } from "../../repsaApi";

const client = new EmailTemplateClient(app_uri, axiosClient());

export default client;
